// Reusable illustrated empty state for dashboard widgets.
// `image` is an imported asset URL (e.g. import url from '../assets/illustrations/x.svg').
type WidgetEmptyStateProps = {
  image: string;
  alt?: string;
  title: string;
  description?: string;
};

export function WidgetEmptyState({ image, alt = '', title, description }: WidgetEmptyStateProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center px-4 py-6 text-center">
      <img src={image} alt={alt} className="mb-4 h-36 w-auto select-none" draggable={false} />
      <p className="text-base font-semibold text-slate-900">{title}</p>
      {description ? <p className="mt-1 max-w-xs text-sm text-slate-500">{description}</p> : null}
    </div>
  );
}
